export const initialZoomMap = 4;
